export function buildShareUrl(origin: string, token: string): string {
  return `${origin.replace(/\/$/, '')}/s/${encodeURIComponent(token)}`;
}

export function extractShareToken(pathname: string): string | null {
  const match = pathname.match(/^\/s\/([^/?#]+)$/);
  if (!match?.[1]) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
